import React from "react";
import { GKLayoutShell } from "@granular/gds-ux-components";

import { usePreOperationsData } from "../next/hooks/operations/preOperations";
import { useFabricFeatureFlag } from "../next/hooks";

import CurrentOperation from "./CurrentOperation";

import Initial from "../legacy/initial";
import { ShellProps } from "./FabricShell";
import { getPlatform } from "../helpers";

const platform = getPlatform();

const Component: React.FC<ShellProps> = (props) => {
  const operationsData = usePreOperationsData();
  const operationsCount = operationsData.operations.length;

  const { UNSAFE_injectedTranslations, ...restProps } = props;

  /**
   * If this feature flag is enabled AND the user has zero operations, we
   * redirect them to the standalone Onboarding app. It will welcome them, give
   * them a nice hug and some wine and cheese, add their operations, and
   * redirect them to Insights.
   */
  const useNewOnboardingExperience = useFabricFeatureFlag({
    key: "use-new-onboarding-experience",
    ignoreOperationId: true,
  });

  if (operationsCount === 0) {
    if (useNewOnboardingExperience) {
      /**
       * NOTE: We cannot use React Router here! The Container cannot (and
       *       should not) handle routing to this *standalone* app. I.e., this
       *       app is outside the routes that the Container handles.
       *
       * NOTE: While we explicitly specify the platform, the Onboarding app
       *       will default to `insights` if this param is unspecified.
       */
      window.location.href = `/onboarding?platform=${platform}`;
    } else {
      return (
        // Because this is rendering some UI, we need GKLayoutShell
        <GKLayoutShell>
          <Initial UNSAFE_injectedTranslations={UNSAFE_injectedTranslations} />
        </GKLayoutShell>
      );
    }
  }

  return <CurrentOperation {...restProps} />;
};

export default Component;
